<script setup lang="ts">
import HeadingSmall from "@/components/HeadingSmall.vue"
import Badge from "@/components/custom/Badge.vue"
import Table from "@/components/custom/Table.vue"
import { Card, CardContent } from "@/components/ui/card"
import { dateFormatter } from "@/lib/formatters"
import type { InsurancesShow, UserRequest } from "@/types/serializers"
import type { Column } from "@/types/table"

defineProps<{
  data: InsurancesShow["history"]
}>()

const columns: Array<Column<UserRequest>> = [
  {
    key: "created_at",
    header: "Creado en",
  },
  {
    key: "type",
    header: "Tipo de solicitud",
  },
  {
    key: "status",
    header: "Estado",
    center: true,
  },
  {
    key: "reviewed_at",
    header: "Revisado en",
    right: true,
  },
]
</script>

<template>
  <Card>
    <CardContent class="flex flex-col gap-4 px-0">
      <HeadingSmall
        class="px-6"
        title="Historial de consultas (últimas 10 registros)"
      />

      <Table :data="data" :columns="columns">
        <template #created_at-cell="{ row }">
          {{ dateFormatter(row.created_at, {}, "dateTime") }}
        </template>
        <template #status-cell="{ row }">
          <Badge class="w-fit" :status="row.status" />
        </template>
        <template #reviewed_at-cell="{ row }">
          {{ dateFormatter(row.reviewed_at, {}, "dateTime") }}
        </template>
      </Table>
    </CardContent>
  </Card>
</template>
